import axios from 'axios'
import { IResponseAgGrid } from '@/shared/models/ag-grid.model'
import { CommonFilterModel, CommonParams } from '@/api/resources/common/shared/models/common.models'
import { ConfigurationCaseValidationSituationConfigurationCreateRequest, ConfigurationCaseValidationSituationConfigurationPatchInBatchRequest, ConfigurationCaseValidationSituationConfigurationResponse } from '@/modules/configurationModule/detail/local-cases/local-case-validation-situations/services/local-case-validation-situations.dto'
import { EntityIdentifiersRequest, EntityIdentifierWithErrorResponse } from '@/shared/models/http/http.model'

class CaseTypeValidationSituationConfigurationServices {
    async paginator(filterModel: CommonFilterModel, params: CommonParams, laboratoryId: number): Promise<IResponseAgGrid<ConfigurationCaseValidationSituationConfigurationResponse>> {
        const response = await axios.put(`/configuration/laboratories/${laboratoryId}/caseValidationSituationConfigurations`, filterModel, { params })
        return response.data
    }

    async getCaseTypeValidationSituationsLaboratoryById(laboratoryId: number, caseValidationSituationsConfigurationId : number): Promise<ConfigurationCaseValidationSituationConfigurationResponse> {
        const response = await axios.get(`/configuration/laboratories/${laboratoryId}/caseValidationSituationConfigurations/${caseValidationSituationsConfigurationId}`)
        return response.data
    }

    async createCaseTypeValidationSituationsLaboratory(laboratoryId: number, request: ConfigurationCaseValidationSituationConfigurationCreateRequest): Promise<ConfigurationCaseValidationSituationConfigurationResponse> {
        const response = await axios.post(`/configuration/laboratories/${laboratoryId}/caseValidationSituationConfigurations`, request)
        return response.data
    }

    async deleteCaseTypeValidationSituationsLaboratory(laboratoryId: number, caseTypeValidationSituationsLaboratoryIds: EntityIdentifiersRequest): Promise<EntityIdentifierWithErrorResponse[]> {
        const response = await axios.delete(`/configuration/laboratories/${laboratoryId}/caseValidationSituationConfigurations/batch`, { data: caseTypeValidationSituationsLaboratoryIds })
        return response.data
    }

    async patchCaseTypeValidationSituationsLaboratory(laboratoryId: number, requests: ConfigurationCaseValidationSituationConfigurationPatchInBatchRequest[]): Promise<EntityIdentifierWithErrorResponse[]> {
        const response = await axios.patch(`/configuration/laboratories/${laboratoryId}/caseValidationSituationConfigurations/batch`, requests)
        return response.data
    }
}

export const caseTypeValidationSituationConfigurationServices = new CaseTypeValidationSituationConfigurationServices()
